import { Component, ElementRef, Input, ViewChild, inject, EventEmitter, Output } from '@angular/core';
import { iCatalogos, iEntrada, iEntregables, mEntrada } from '../entrada.interface';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators, FormsModule, FormControl, ValidatorFn } from '@angular/forms';
import { EntradaService } from '../entrada.service';
import { LoadingService } from '../../loading/loading.service';
import { AlertaService } from '../../alerta/alerta.service';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { UsuarioService } from '../../usuario/usuario.service';
import { firstValueFrom, Observable, Subject, Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../app.state';
import { selectCatalogos } from '../../states/catalogos/selector';
import { selectEntrada, selectEntradaTema } from '../../states/entrada/selector';
import { sortCatalogo } from '../../utils';
import { cargaEntradaAnalista, cargaEntradaSupervisor, cargaEntradaCoordinador, cargaEntradaCampos } from '../../states/entrada/actions';
import { selectEntregables } from '../../states/entregables/selector';
import { emit } from 'process';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { selectUsuario } from '../../states/usuario/selector';
import { iUsuario } from '../../usuario/usuario.interface';

@Component({
  selector: 'app-add-edit-asignacion-responsables',
  standalone: true,
  imports: [ReactiveFormsModule, MatToolbarModule, MatButtonModule, MatIconModule, MatSlideToggleModule, MatInputModule, MatSelectModule, MatFormFieldModule, FormsModule, CommonModule],
  templateUrl: './add-edit-asignacion-responsables.component.html',
  styleUrl: './add-edit-asignacion-responsables.component.css'
})
export class AddEditAsignacionResponsablesComponent {
  private active = inject(ActivatedRoute);
  private loadingService = inject(LoadingService);
  private entradaService = inject(EntradaService);
  private usuarioService = inject(UsuarioService);
  private alertaService = inject(AlertaService);
  private formBuilder: FormBuilder = inject(FormBuilder);
  private readonly store: Store<AppState> = inject(Store);
  private readonly stateCatalogo: any = this.store.pipe(select(selectCatalogos));
  private readonly stateEntrada: any = this.store.pipe(select(selectEntrada));
  private readonly stateUsuario: any = this.store.pipe(select(selectUsuario));
  private readonly stateEntradaTema: any = this.store.pipe(select(selectEntradaTema));
  private readonly stateEntregables: any = this.store.pipe(select(selectEntregables));
  private idEntrada = this.active.snapshot.params['id'];
  private idTema = this.active.snapshot.params['tema'];
  private subscriptions = new Subscription();
  
  @Input() listenToFather!: Observable<boolean>;
  @Output() sendToFather: Subject<any> = new Subject();
  
  public oEntrada: iEntrada;
  public oUsuario: iUsuario;
  public oCatalogos: iCatalogos;
  public oEntregables: iEntregables[];
  public oEntradaOriginal: iEntrada;
  public formAsigResp!: FormGroup;
  public catAnalista: any[] = [];
  public catSupervisor: any[] = [];
  public catCoordinador: any[] = [];
  public edicion: boolean = false;
  public deshabilitado: boolean = false;
  public temaBackUp: string = '';

  constructor() {
    this.loadingService.show();
    
    this.oEntrada = structuredClone(this.stateEntrada.state().entrada);
    this.oUsuario = structuredClone(this.stateUsuario.state().usuario);
    this.oCatalogos = structuredClone(this.stateCatalogo.state().catalogos);
    this.oEntregables = structuredClone(this.stateEntregables.state().entregables);
    this.oEntradaOriginal = structuredClone(this.stateEntrada.state().entrada);

    this.formAsigResp = this.formBuilder.group({
      banEntregables: [this.oEntrada.banEntregables],
      seguimiento: [this.oEntrada.seguimiento],
      seguimiento_justificacion: [this.oEntrada.seguimiento_justificacion, [Validators.required]],
      analista: [this.oEntrada.analista, [Validators.required]],
      supervisor: [this.oEntrada.supervisor, [Validators.required]],
      coordinador: [this.oEntrada.coordinador, [Validators.required]]
    });

    this.formAsigResp.get('banEntregables')?.valueChanges.subscribe(value => {
      if(value == false && this.oEntregables.length > 0) {
        this.formAsigResp.get('banEntregables')?.setValue(true, { emitEvent: false });
        this.alertaService.open("Error", "No puedes deshabilitar este campo, sin antes eliminar todos los entregables.");
        return;
      }

      this.switchToggle();
      this.store.dispatch(cargaEntradaCampos({ oData: { 'banEntregables': value }}));
    });

    this.formAsigResp.get('seguimiento')?.valueChanges.subscribe(value => {
      this.switchToggle();
      this.store.dispatch(cargaEntradaCampos({ oData: { 'seguimiento': value }}));
    });

    this.formAsigResp.get('seguimiento_justificacion')?.valueChanges.subscribe(value => {
      this.store.dispatch(cargaEntradaCampos({ oData: { 'seguimiento_justificacion': value }}));
    });

    this.formAsigResp.get('analista')?.valueChanges.subscribe(value => {
      if(value != "") {
        const oAnalista =  this.catAnalista.filter(item => item.id == value)[0];
        this.store.dispatch(cargaEntradaAnalista({ oAnalista }));
      } else {
        this.store.dispatch(cargaEntradaCampos({ oData: { 'analista': '', 'analista_descripcion': '' } }));
      }
    });

    this.formAsigResp.get('supervisor')?.valueChanges.subscribe(value => {
      if(value != "") {
        const oSupervisor =  this.catSupervisor.filter(item => item.id == value)[0];
        this.store.dispatch(cargaEntradaSupervisor({ oSupervisor }));
      }  else {
        this.store.dispatch(cargaEntradaCampos({ oData: { 'supervisor': '', 'supervisor_descripcion': '' } }));
      }
    });

    this.formAsigResp.get('coordinador')?.valueChanges.subscribe(value => {
      if(value != "") {
        const oCoordinador =  this.catCoordinador.filter(item => item.id == value)[0];
        this.store.dispatch(cargaEntradaCoordinador({ oCoordinador }));
      }  else {
        this.store.dispatch(cargaEntradaCampos({ oData: { 'coordinador': '', 'coordinador_descripcion': '' } }));
      }
    });

    ///////////////////////////// ONCHANGE BUSINESS RULES //////////////////////////////
    this.temaBackUp = this.oEntrada.tema;
    this.creaCatalogos();
    this.switchToggle();
    ////////////////////////////////////////////////////////////////////////////////////

    this.loadingService.hide();
  }

  async ngOnInit() {
    this.subscriptions.add(this.store.select(selectEntrada).subscribe((oEntrada) => {
      this.oEntrada = structuredClone(oEntrada);
    }));

    this.subscriptions.add(this.store.select(selectEntradaTema).subscribe((tema) => {
      if(tema != '')
        this.cambioTema(tema);
    }));
    
    this.subscriptions.add(this.store.select(selectEntregables).subscribe((oEntregables) => {
      this.oEntregables = structuredClone(oEntregables);
    }));
    
    this.formAsigResp.statusChanges.subscribe((status:any) => {
      if(this.oUsuario && this.oUsuario.rol == 1)
        status = this.validacionCampos();

      this.sendToFather.next({formAsigResp: status});
    });

    this.subscriptions.add(this.listenToFather.subscribe((oData: any) => {
      if(oData.accion == 'disabled') {
        this.deshabilitado = oData.deshabilitado;
        if(oData.deshabilitado) {
          this.formAsigResp.disable({emitEvent: false});
        } else {
          this.formAsigResp.enable({emitEvent: false});
          this.switchToggle();
          this.switchSelect();
        }
      }
    }));

    if(this.idEntrada != 'add') {
      this.edicion = true;
      this.deshabilitado = true;
      this.formAsigResp.disable({emitEvent: false});
    }

    this.validacionFormulario();
  }
  
  validacionFormulario() { 
    Promise.resolve().then( () => {
      const status = this.formAsigResp.status;
      this.sendToFather.next({formAsigResp: status});
    });
  }

  validacionCampos() {
    const oData = {
      banEntregables:             this.formAsigResp.controls['banEntregables'].value,
      seguimiento:                this.formAsigResp.controls['seguimiento'].value,
      seguimiento_justificacion:  this.formAsigResp.controls['seguimiento_justificacion'].value,
      analista:                   this.formAsigResp.controls['analista'].value,
      supervisor:                 this.formAsigResp.controls['supervisor'].value,
      coordinador:                this.formAsigResp.controls['coordinador'].value
    };

    if(oData.seguimiento && oData.seguimiento_justificacion == '') {
      return 'INVALID'
    }

    if((oData.banEntregables || oData.seguimiento) && (oData.analista == '' || oData.supervisor == '' || oData.coordinador == '')) {
      return 'INVALID'
    }

    return 'VALID';
  }

  businessRules(): void {
    if(this.oEntrada?.banEntregables || this.oEntrada?.seguimiento) {
      this.switchToggle();
    }
  }

  creaCatalogos() {
    this.catAnalista = this.oCatalogos.catUsuarios.filter(item => item.activo && item.mostrar && item.rol == 1);
    this.catSupervisor = this.oCatalogos.catUsuarios.filter(item => item.activo && item.mostrar && item.rol == 2);
    this.catCoordinador = this.oCatalogos.catUsuarios.filter(item => item.activo && item.mostrar && item.rol == 3);

    if(this.oEntrada.analista && this.oEntrada.supervisor && this.oEntrada.coordinador) {
      let analista: any = this.oCatalogos.catUsuarios.filter(item => item.id == this.oEntrada.analista)[0];
      let supervisor: any = this.oCatalogos.catUsuarios.filter(item => item.id == this.oEntrada.supervisor)[0];
      let coordinador: any = this.oCatalogos.catUsuarios.filter(item => item.id == this.oEntrada.coordinador)[0];

      if(this.catAnalista.filter(item => item.id == this.oEntrada.analista).length == 0) {
        if(analista) {
          analista.disabled = true;
          this.catAnalista.push(analista);
        } else {
          const analistaUsuario = this.generaUsuarioResponsable(this.oEntrada.analista, this.oEntrada.analista_descripcion, 1);
          this.catAnalista.push(analistaUsuario);
        }
        this.catAnalista = sortCatalogo(this.catAnalista, 'nombre');
      }

      if(this.catSupervisor.filter(item => item.id == this.oEntrada.supervisor).length == 0) {
        if(supervisor) {
          supervisor.disabled = true;
          this.catSupervisor.push(supervisor);
        } else {
          const supervisorUsuario = this.generaUsuarioResponsable(this.oEntrada.supervisor, this.oEntrada.supervisor_descripcion, 2);
          this.catSupervisor.push(supervisorUsuario);
        }
        this.catSupervisor = sortCatalogo(this.catSupervisor, 'nombre');
      }

      if(this.catCoordinador.filter(item => item.id == this.oEntrada.coordinador).length == 0) {
        if(coordinador) {
          coordinador.disabled = true;
          this.catCoordinador.push(coordinador);
        } else {
          const cordinadorUsuario = this.generaUsuarioResponsable(this.oEntrada.coordinador, this.oEntrada.coordinador_descripcion, 3);
          this.catCoordinador.push(cordinadorUsuario);
        }
        this.catCoordinador = sortCatalogo(this.catCoordinador, 'nombre');
      }
    }
  }

  restaurar() {
    this.formAsigResp.patchValue({
      banEntregables: this.oEntradaOriginal?.banEntregables,
      seguimiento: this.oEntradaOriginal?.seguimiento,
      seguimiento_justificacion: this.oEntradaOriginal?.seguimiento_justificacion,
      analista: this.oEntradaOriginal?.analista,
      supervisor: this.oEntradaOriginal?.supervisor,
      coordinador: this.oEntradaOriginal?.coordinador
    });

    this.businessRules();
  }

  switchToggle() {
    const banEntregables = this.formAsigResp.get('banEntregables')?.value;
    const seguimiento = this.formAsigResp.get('seguimiento')?.value;

    if(seguimiento) {
      this.formAsigResp.get('seguimiento_justificacion')?.enable();
    } else {
      this.formAsigResp.get('seguimiento_justificacion')?.setValue('');
      this.formAsigResp.get('seguimiento_justificacion')?.disable(); 
    }

    if(banEntregables || seguimiento) {
      this.formAsigResp.get('analista')?.enable();
      this.formAsigResp.get('supervisor')?.enable();
      this.formAsigResp.get('coordinador')?.enable();
    }

    if(!banEntregables && !seguimiento) {
      this.formAsigResp.get('analista')?.setValue('');
      this.formAsigResp.get('supervisor')?.setValue('');
      this.formAsigResp.get('coordinador')?.setValue('');
      this.formAsigResp.get('analista')?.disable();
      this.formAsigResp.get('supervisor')?.disable();
      this.formAsigResp.get('coordinador')?.disable();
    }

    if((banEntregables || seguimiento) && this.oEntrada.tema == "") {
      this.alertaService.open("Alerta", "Para visualizar información en los catálogos de responsables, primero debe asignar un tema a la entrada.")
      this.formAsigResp.get('seguimiento')?.setValue(false, { emitEvent: false });
      this.formAsigResp.get('banEntregables')?.setValue(false, { emitEvent: false });
      this.switchToggle();
    }
  }
  
  cambioTema(tema: string) {
    
    if(this.temaBackUp == '' && this.temaBackUp != tema) {
      this.temaBackUp = tema;
      return;
    }
    
    let oData = this.formAsigResp.value;

    if(this.formAsigResp.controls['supervisor'].disabled)
      oData.supervisor = this.formAsigResp.controls['supervisor'].value;

    if(this.formAsigResp.controls['coordinador'].disabled)
      oData.coordinador = this.formAsigResp.controls['coordinador'].value;


    if(this.temaBackUp != tema && (oData.banEntregables || oData.seguimiento)) {
      let responsables: any = [];
      let htmlResponsables = '';
        
      if(oData.analista && this.catAnalista.filter(item => item.id == oData.analista && item.temas_permiso.includes(tema) && !item.disabled).length == 0) {
        htmlResponsables += `<li>Analista: ${this.oEntrada.analista_descripcion}</li>`
        responsables.push({rol: "Analista", nombre: this.oEntrada.analista_descripcion});
      }
      if(oData.supervisor != '' && this.catSupervisor.filter(item => item.id == oData.supervisor && item.temas_permiso.includes(tema) && !item.disabled).length == 0) {
        htmlResponsables += `<li>Supervisor: ${this.oEntrada.supervisor_descripcion}</li>`
        responsables.push({rol: "Supervisor", nombre: this.oEntrada.supervisor_descripcion});
      }
      if(oData.coordinador != '' && this.catCoordinador.filter(item => item.id == oData.coordinador && item.temas_permiso.includes(tema) && !item.disabled).length == 0) {
        htmlResponsables += `<li>Coordinador: ${this.oEntrada.coordinador_descripcion}</li>`
        responsables.push({rol: "Coordinador", nombre: this.oEntrada.coordinador_descripcion});
      }

      if(responsables.length > 0) {
        this.alertaService.confirmHTML({
          title: 'Alerta',
          description: 'Los siguientes usuarios responsables, no cuentan con permisos para el nuevo tema asignado:',
          descriptionHTML: 
            `<ul class='lista-responsables'>
              ${htmlResponsables}
            </ul><br>
            ¿Desea actualizar el tema de la entrada y asignar nuevos responsables?`,
            aceptar: 'ACTUALIZAR'
        }).afterClosed().subscribe((result:any) => {
          if(result) {
            this.temaBackUp = this.oEntrada.tema;
            for(let i in responsables) {
              if(responsables[i].rol == "Analista") {            
                this.formAsigResp.get('analista')?.setValue('');
              } else if(responsables[i].rol == "Supervisor") {
                this.formAsigResp.get('supervisor')?.setValue('');
              } else if(responsables[i].rol == "Coordinador") {
                this.formAsigResp.get('coordinador')?.setValue('');
              }
            }
          } else {
            this.store.dispatch(cargaEntradaCampos({ oData: { 'tema': this.temaBackUp }}));
          }
        });
      }
    }
  }

  switchSelect() {
    const banEntregables = this.formAsigResp.get('banEntregables')?.value;
    const seguimiento = this.formAsigResp.get('seguimiento')?.value;
    
    if(banEntregables || seguimiento) {
      if(this.oUsuario.rol == 1) {
        this.formAsigResp.get('supervisor')?.disable({emitEvent: false});
        this.formAsigResp.get('coordinador')?.disable({emitEvent: false});
      } else {
        this.formAsigResp.get('supervisor')?.enable({emitEvent: false});
        this.formAsigResp.get('coordinador')?.enable({emitEvent: false});
      }
    }
  }

  changeTab() {
    this.sendToFather.next({
      'changeTab': 1
    });
  }

  generaUsuarioResponsable(idUsuario:string, descripcionUsuario:string, rolUsuario: number) {
    let mail = descripcionUsuario.split(" | ")[1];
    let nombre = descripcionUsuario.split(" | ")[0];

    return {
      activo: true,
      formaEnvio: true,
      mostrar: true,
      disabled: true,

      id: idUsuario,
      mail: mail,
      nombre: nombre,
      rol: rolUsuario,
      temas: { 
        '-KcOsYIkmr2FHgi4ubym': {notificacion: false, permiso: 3},
        '-KcOsYIoTX3wdcK4DMjF': {notificacion: false, permiso: 3},
        '-KcOsYIprL1TVCF2uyaO': {notificacion: false, permiso: 3},
        '-KdfegAIz9pHjb6ak32K': {notificacion: false, permiso: 3}
      },
      temas_permiso: [
        '-KcOsYIkmr2FHgi4ubym',
        '-KcOsYIoTX3wdcK4DMjF',
        '-KcOsYIprL1TVCF2uyaO',
        '-KdfegAIz9pHjb6ak32K'
      ]
    };
  }

  ngOnDestroy () {
    this.subscriptions.unsubscribe();
  }
}